import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths } from "../../utils";

// Base route constant
const baseRoute = `/edit-profile`;

// * Route configuration object for editProfile-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const editProfileRoutesObj = {
  edit: baseRoute,
} as const;

// ! these are breadcrumbs translation not page title
const editProfileRouteTranslation: IRouteTranslation<
  typeof editProfileRoutesObj
> = {
  edit: "editProfile",
};

// * Extracts the route parameters for the editProfile route configuration.
export type IEditProfileRouteParams = IExtractRouteParamMap<
  typeof editProfileRoutesObj
>;

// * Path functions for the editProfile routes.
export const editProfilePath = createPaths<
  typeof editProfileRoutesObj,
  IEditProfileRouteParams
>(editProfileRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const editProfileBreadcrumbs = createBreadcrumbObject<
  typeof editProfileRoutesObj
>(editProfileRoutesObj, editProfileRouteTranslation);
